
import { defineComponent, onMounted, reactive, toRefs, ref } from "vue";
import ApiArticle from "@/request/apis/api_article";
import { IArticleDetail } from "@/models/article_model";
import { useRoute } from "vue-router";
import ApiSetting from "@/request/apis/api_setting";
interface IState {
  detail?: IArticleDetail;
  printData: any;
  totalScore: any;
  educations: any;
  works: any;
}

export default defineComponent({
  name: "ArticleDetail",
  setup() {
    let editId: any;
    const route = useRoute();
    const state: IState = reactive({
      detail: undefined,
      printData: "",
      educations: [],
      works: [],
      totalScore: 0,
    });

    // 获取文章详情
    const getDetail = async () => {
      const { id } = route.query;
      //IArticleDetail
      const params = { id: id };
      const res = await ApiSetting.InterviewFormInfo(params);
      if (res && res.error_code === 0) {
        state.printData = res.data;
        state.educations = state.printData.experience.educations;
        state.works = state.printData.experience.works;
        state.printData.questions.forEach((item, index) => {
          if (item.type == 4) {
            item.answer_lable = item.answer;
          } else {
            item.questionOptions.forEach((item2, index2) => {
              if (item2.index == item.user_answer.answer[0]) {
                item.answer_lable = item2.value;
              }
            });
          }
        });
        console.log(state.printData,12312);
      }
    };

    const columns = [
      {
        title: "结果",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "题号",
        dataIndex: "number",
        key: "number",
      },
      {
        title: "得分",
        dataIndex: "score",
        key: "score",
      },
    ];

    const print = ref({
      id: "printBox", //这里的id就是上面我们的打印区域id，实现指哪打哪
      popTitle: "配置页眉标题", // 打印配置页上方的标题
      extraHead: "", // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
      previewPrintBtnLabel: "预览结束，开始打印", // 打印预览的标题下方的按钮文本，点击可进入打印
      zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
      previewBeforeOpenCallback() {
        console.log("正在加载预览窗口！");
      }, // 预览窗口打开之前的callback
      previewOpenCallback() {
        console.log("已经加载完预览窗口，预览打开了！");
      }, // 预览窗口打开时的callback
      beforeOpenCallback() {
        console.log("开始打印之前！");
      }, // 开始打印之前的callback
      openCallback() {
        console.log("执行打印了！");
      }, // 调用打印时的callback
      closeCallback() {
        console.log("关闭了打印工具！");
      }, // 关闭打印的callback(无法区分确认or取消)
      clickMounted() {
        console.log("点击v-print绑定的按钮了！");
      },
    });

    onMounted(() => {
      getDetail();
    });

    return {
      ...toRefs(state),
      print,
      columns,
    };
  },
});
